




































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { LoadingState } from '@/entities/LoadingState';
import { VinSearchModuleTypes } from '@/store/modules/vin-search';
import SmoothReflow from '@/components/smooth-reflow/SmoothReflow.vue';
import BaseMixin from '@/mixins/BaseMixin';
import URI from 'urijs';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import VinSearchResultItem from '@/components/vin-search/VinSearchResultItem.vue';
import { VinSearchResult as VinSearchResultModel } from '@/entities/vin-search/VinSearchResult';

@Component({
    components: {
        SmoothReflow,
        LoadingIndicator,
        VinSearchResultItem,
    },
})
export default class VinSearchResult extends Mixins(BaseMixin) {
    @Prop({ type: String })
    private catalogueSearchLink!: string;

    private closeResults(): void {
        this.$store.dispatch(VinSearchModuleTypes.actions.closeVinSearchResults);
    }

    private get searchTerm(): string {
        return this.$store.getters[VinSearchModuleTypes.getters.searchTerm];
    }

    private get vinSearchResult(): VinSearchResultModel {
        return this.$store.getters[VinSearchModuleTypes.getters.vinSearchResult];
    }

    private get showSearchResults(): boolean {
        return this.$store.getters[VinSearchModuleTypes.getters.searchResultsLoadingState] === LoadingState.Loaded;
    }

    private get catalogueSearchLinkForSearchTerm(): string {
        return new URI(this.catalogueSearchLink).addQuery({ searchTerm: this.searchTerm }).toString();
    }

    private get showNoResultsFoundText(): boolean {
        return !this.vinSearchResult;
    }

    private get showGoToCatalogueSearchButton(): boolean {
        return !this.vinSearchResult || !this.vinSearchResult.partCatalogueUrl;
    }
}
